export default "__VITE_ASSET__5J84TCCW__"